import axios from "axios"
import {omit} from "lodash"
import {normalize} from "normalizr"
import {INTERVENANTS_ENDPOINTS} from "../../../constants/endpoints"
import {getErrorMessage} from "../../../services/api"
import {getPageNumber} from "../../../services/pagination"
import {
    GET_CHECKBOOKS_OF_REFUND_FAILURE,
    GET_CHECKBOOKS_OF_REFUND_REQUEST,
    GET_CHECKBOOKS_OF_REFUND_SUCCESS,
} from "./checkbooksActionsType"
import * as schema from "./checkbooksSchema"

/**
 * Used to sort field in table
 */
const checkbooksBackEndField = {
    id: "id",
    millesime: "millesime",
    value: "valeur",
    beneficiaryName: "nomBeneficiaire",
}

export const getBackEndField = accessor => checkbooksBackEndField[accessor]

/**
 * Thunk to get the list of title of a refund of by providing refundId and the page number
 * Dispatch on request and on success or failure.
 */
export const getCheckbooksOfRefund =
    (refundId, page, sortedField, sortDirection, limit = 10) =>
    dispatch => {
        dispatch({
            type: GET_CHECKBOOKS_OF_REFUND_REQUEST,
        })

        const params = {
            page,
            tri: sortedField + "," + sortDirection,
            taille: limit,
        }

        return axios.get(INTERVENANTS_ENDPOINTS.retrieveRefund(refundId), {params}).then(
            response => {
                let pagination = omit(response.data, ["content"])
                dispatch({
                    type: GET_CHECKBOOKS_OF_REFUND_SUCCESS,
                    response: normalize(
                        response.data.content.map(checkbook => ({
                            id: checkbook.id,
                            millesime: checkbook.millesime,
                            value: parseFloat(checkbook.valeur).toFixed(2),
                            beneficiaryName: checkbook.nomBeneficiaire,
                        })),
                        schema.arrayOfCheckbooks,
                    ),
                })
                pagination = {
                    ...pagination,
                    maxPages: pagination.totalPages,
                    totalResults: pagination.totalElements,
                    number: getPageNumber(pagination.number),
                }

                return Promise.resolve(pagination)
            },
            error => {
                dispatch({
                    type: GET_CHECKBOOKS_OF_REFUND_FAILURE,
                    message: getErrorMessage(error),
                })
                return Promise.reject(error)
            },
        )
    }
